import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { CustomAnimations, StateAnimation } from "../shared/util/Animations";
import { Observable, Subject, Subscription } from "rxjs";

import { CardType } from "./cards/card-type";
import { CardsComponent } from "./cards/cards.component";
import { DashboardService } from "./dashboard.service";
import { PageService } from "../shared/layout/services/page.service";
import { PanelHeaderComponent } from "./panel-header/panel-header.component";
import { TabVo } from "../shared/models/tab-vo";
import { indicate } from "maps-angular-components";
import { trigger } from "@angular/animations";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  animations: [trigger("fade", CustomAnimations.fadeAnimation(500))],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("panelHeaderComponent", { static: false })
  panelHeaderComponent: PanelHeaderComponent;

  private subscriptions = new Subscription();

  @ViewChild("cardsComponent", { static: false })
  cardsComponent: CardsComponent;

  StateAnimation = StateAnimation;

  CardType = CardType;

  canShowInit = false;

  canShow = false;

  interval;

  cardTypeSelected: CardType = CardType.NENHUM;

  pageCadastroVO: TabVo = new TabVo();

  dataUltimoProcessamento$ = new Observable<string>();
  loadingUltimaDataProcessamento$ = new Subject<boolean>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private page: PageService,
    private dashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.page.defineTitle("DASHBOARD");
    this.canShowInit = true;
    this.changeDetectorRef.detectChanges();
  }

  refreshDashBoard() {
    this.cardsComponent.refreshCards();
    this.panelHeaderComponent.refreshValues();
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {

    this.dataUltimoProcessamento$ = this.dashboardService
      .getUltimaDataProcessamento()
      .pipe(indicate(this.loadingUltimaDataProcessamento$));

    this.interval = setInterval(() => {
      this.refreshDashBoard();
    }, 60000);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    this.subscriptions.unsubscribe();
  }

  setCard(e: CardType) {
    if (this.cardTypeSelected === e) {
      return;
    }
    this.cardTypeSelected = e;
    this.canShow = false;
    this.changeDetectorRef.detectChanges();
  }

  animationDone(e) {
    this.canShow = true;
  }

  setPageCadastroVO($event: any) {}
}
